import { getCreationForm } from "../createPage/createpageTemplate";
import { generateBentoLayoutWithMultipleRows, generateRowLayoutFromPreset, wrapComponentsForBento, wrapComponentsForDashboard } from "../createPage/dashboardLayout";
import { getDashboardTemplate } from "../createPage/dashboardPageTemplate";

export function getDashboardForm(
  fieldComps: any,
  viewVariationKey: any,
  title: any,
): any {
  const variationConfig = viewVariationKey;
  let layout = []
    const layoutdComps = wrapComponentsForDashboard(fieldComps, variationConfig);
    const layoutForRenderer = Array.isArray(layoutdComps)
    ? layoutdComps
    : [layoutdComps];
   layout =  getDashboardTemplate(layoutForRenderer, title);
  //console.log(layout);
  return layout;
}


export function getDashboardBentoForm(
  fieldComps: any,
  viewVariationKey: any,
  title: any,
  type:any,
  columns:any
): any {
  const variationConfig = viewVariationKey;
  let layout = []
  let layoutdComps:any = {};
  if(type == 'RANDOM-BENTO') layoutdComps = wrapComponentsForBento(fieldComps, variationConfig);
  if(type == 'ROW-UNIQUE') layoutdComps = generateBentoLayoutWithMultipleRows(fieldComps);
  if(type == 'PRESET') layoutdComps = generateRowLayoutFromPreset(fieldComps, columns, 6);

  //  const layoutdComps = wrapComponentsForBento(fieldComps, variationConfig);
    //    const layoutdComps = generateBentoLayoutWithMultipleRows(fieldComps);

  //   const layoutdComps = generateRowLayoutFromPreset(fieldComps,[3, 5, 4], 5 );
    //  layoutdComps = generateRowLayoutFromPreset(fieldComps,[3, 3, 6], 5 );
    const layoutForRenderer = Array.isArray(layoutdComps)
    ? layoutdComps
    : [layoutdComps];
   layout =  getDashboardTemplate(layoutForRenderer, title);
  //console.log(layout);
  return layout;
}